export default {
  app: {
    privacy: {
      policy: 'informativa sulla privacy',
      expansive: 'Utilizzando Expansive, accetti l’{action} Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sessione scaduta',
    sessionExpiredDescription:
      "La tua sessione è scaduta. Effettua nuovamente l'accesso per continuare a utilizzare l'applicazione.",
  },
  components: {
    appContainer: {
      chooseLanguage: 'Scegli la lingua',
      chooseLanguageDescription:
        "Scegli la tua lingua preferita per l'applicazione. Questo cambierà la lingua dell'interfaccia e dei contenuti.",
    },
    userSelection: {
      cancel: 'Annulla',
      createNewUser: 'Il loro nome non è elencato',
      newUser: 'Nuovo utente',
      selectAnExistingUser: 'Seleziona un utente esistente',
      selectUserHint: 'Seleziona un utente esistente o creane uno nuovo per continuare.',
      startTypingToSearch: 'Inizia a digitare...',
    },
    verification: {
      codeVerification: {
        continue: 'Continua',
        header: 'Inserisci il codice di accesso al sito',
        invalidCode: 'Codice non valido, riprova.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Continua senza verificare la posizione',
        enterSiteAccessCode: 'Inserisci il codice di accesso al sito',
        locationNotEnabledOrAvailable: 'Perché vedo questo?',
        notAvailable: {
          description: 'La posizione GPS non è supportata su questo dispositivo.',
          header: 'Posizione non supportata',
        },
        notEnabled: {
          description:
            'I servizi di localizzazione non sono abilitati o il permesso non è stato concesso.',
          header: 'Posizione non abilitata',
        },
        notVerified: {
          description: 'Il GPS indica che non sei sul sito.',
          header: 'Posizione non verificata',
        },
        tryAgain: 'Riprova',
        unavailable: {
          description: 'Non siamo riusciti a verificare la tua posizione GPS.',
          header: 'Posizione non disponibile',
        },
        unknown: {
          description: 'Non siamo in grado di determinare la tua posizione.',
          header: 'Posizione sconosciuta',
        },
        verified: {
          description: 'Il GPS indica che sei sul sito.',
          header: 'Posizione verificata',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Nessuna risorsa trovata',
        emptyDescription: 'Non ci sono risorse associate a questo ordine di lavoro.',
        warrantyParts: 'Garanzia dei pezzi scade',
        serialNumber: 'Numero di serie',
        none: '<nessuno>',
      },
      updates: {
        emptyTitle: 'Nessun aggiornamento trovato',
        emptyDescription: 'Non ci sono aggiornamenti per questo ordine di lavoro.',
        unknownUser: 'Utente sconosciuto',
        none: 'Nessuno',
        addComment: {
          buttonLabel: 'Aggiungi commento',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Pericoli',
          no: 'No',
          yes: 'Sì',
        },
      },
    },
    attachmentsList: {
      attachments: 'Allegati',
      documents: 'Documenti',
      siteDocuments: 'Documenti del sito',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Pericoli',
        induction: 'Induzione',
        safeToProceed: 'Sicuro per procedere',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Data di scadenza',
        activeSessions: 'Sessioni attive',
        activeSessionsDescription:
          'Sei già registrato nei seguenti ordini di lavoro. Devi uscire da questi ordini di lavoro prima di registrarti in un nuovo ordine di lavoro.',
        resumeSession: 'Riprendi',
        startTime: 'Iniziato alle',
        unexpectedErrorTitle: 'Errore imprevisto',
        unexpectedErrorMessage:
          'Si è verificato un errore imprevisto durante la creazione delle tue sessioni. Riprova più tardi.',
        engineerNotFound: 'Ingegnere non trovato',
        engineerNotFoundDescription:
          "L'ingegnere che stai cercando di registrare non è presente nel sistema. Contatta il tuo amministratore.",
      },
      verification: {
        code: {
          description:
            'Per registrarti, ottieni il codice a 4 cifre dal responsabile del sito o dal contatto designato.',
        },
        geo: {
          continue: 'Continua',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Si prega di ottenere il codice di accesso dal responsabile del sito o dal contatto designato per completare la visita.',
            checkOut: 'Check-out',
            completeBeforeLeaving: 'Completa il seguente modulo prima di andare via.',
            continue: 'Continua',
            noResolutionSelected: 'Seleziona una risoluzione prima di continuare.',
            quoteRequired: {
              hint: 'Visita completata, preventivo a seguire',
              label: 'Preventivo richiesto',
            },
            returnVisitRequired: {
              hint: 'Torneremo di nuovo per completare',
              label: 'Visita di ritorno richiesta',
            },
            serviceCompleted: {
              hint: 'Nessuna ulteriore azione richiesta',
              label: 'Servizio completato',
            },
            uploadCheckout: 'Carica un file, foto o video',
            visitNotes: 'Note della visita',
            workOrderResolution: 'Risoluzione ordine di lavoro',
            enterNotes: 'Inserisci eventuali note qui...',
            errors: {
              timedOut: 'Timeout, superati 30 secondi. Per favore riprova.',
              closingSession: 'Errore durante la chiusura della sessione',
            },
          },
          success: {
            description:
              'Grazie per aver visitato {site}. | {site} ha ancora 1 ordine di lavoro aperto. | {site} ha ancora {count} ordini di lavoro aperti.',
            endVisit: 'Termina visita',
            header: 'Hai effettuato il check-out con successo',
            viewWorkOrders: 'Registrati in un altro ordine di lavoro',
          },
          verification: {
            code: {
              description:
                'Per effettuare il check-out, ottieni il codice a 4 cifre dal responsabile del sito o dal contatto designato.',
              continue: 'Continua',
            },
            geo: {
              checkOut: 'Check-out',
              continue: 'Continua',
            },
          },
        },
        detail: {
          assets: 'Risorse',
          call: 'Chiama',
          checkOut: 'Check-out',
          closed: 'Chiuso',
          details: 'Dettagli',
          dueBy: 'Data di scadenza',
          manageEngineers: 'Gestisci ingegneri',
          notAvailable: 'Non disponibile',
          pointOfContact: 'Persona di riferimento',
          siteAccessTimes: 'Orari di accesso al sito',
          siteAccessInstructions: 'Istruzioni di accesso',
          siteAddress: 'Indirizzo del sito',
          siteNotes: 'Note del sito',
          siteTelephone: 'Telefono del sito',
          siteLocation: 'Posizione del sito',
          updates: 'Aggiornamenti',
          more: 'Altro',
          mismatchErrorTitle: 'Errore ordine di lavoro',
          mismatchErrorMessage:
            "L'ordine di lavoro che stai cercando di accedere non corrisponde a quello in cui sei attualmente registrato. Controlla il tuo ordine di lavoro e riprova.",
          siteDocuments: 'Documenti del sito',
          validFrom: 'Valido da',
          validUntil: 'Valido fino a',
          documentName: 'Nome documento',
          documentType: 'Tipo di documento',
          attachments: 'File ordine di lavoro',
          download: 'Scarica',
          workDetails: 'Dettagli lavoro',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Aggiungi ingegnere assistente',
            assistantEngineers: 'Ingegneri assistenti',
            description: 'Per motivi di sicurezza, specifica i nomi di ogni ingegnere sul sito.',
            editMainEngineer: 'Modifica ingegnere principale',
            errors: {
              creatingEngineer: "Errore durante la creazione dell'ingegnere",
              creatingSession: 'Errore durante la creazione della sessione',
            },
            header: 'Ingegneri sul sito',
            mainEngineer: 'Ingegnere principale',
            newAssistantEngineer: 'Inserisci il loro nome completo',
            next: 'Avanti',
            removeEngineer: 'Rimuovi ingegnere',
            selectExistingAssistantEngineer: 'Inizia a digitare il loro nome',
          },
          index: {
            description: 'Per motivi di sicurezza, specifica i nomi di ogni ingegnere sul sito.',
            errorCreatingEngineer: "Errore durante la creazione dell'ingegnere, riprova.",
            header: 'Ingegneri sul sito',
            hintMainEngineer: "Inserisci il nome completo dell'ingegnere principale",
            newMainEngineer: 'Nuovo ingegnere principale',
            next: 'Avanti',
            selectExistingMainEngineer: 'Seleziona un ingegnere principale esistente',
            yes: 'Sì',
            no: 'No',
            mainEngineerLabel: "Sei tu l'ingegnere principale?",
          },
        },
        index: {
          callUsOn: 'Chiamaci al {phoneNumber}',
          description: 'Non riesci a trovare quello che cerchi?',
          dueBy: 'Data di scadenza',
          header: 'Seleziona ordine di lavoro',
          notAvailable: 'Non disponibile',
          searchWorkOrders: 'Cerca ordini di lavoro...',
        },
        manageEngineers: {
          manageEngineers: 'Gestisci ingegneri',
          notWorking: 'Lavoratori inattivi',
          pause: 'Pausa',
          resume: 'Riprendi',
          workingNow: 'Lavoratori attivi',
          startTime: 'Ora di inizio',
          endTime: 'Ora di fine',
          duration: 'Durata',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Feedback',
            feedbackDescription:
              "Fornisci un feedback sull'ordine di lavoro per aiutarci a migliorare i nostri servizi.",
            feedbackLabel: 'Feedback',
            filesLabel: 'Allegati',
            submissionLabel: 'Invia feedback',
          },
          hazards: {
            back: 'Indietro',
            hazards: 'Pericoli',
            next: 'Avanti',
            no: 'No',
            noTasksForHazard: 'Non ci sono attività da completare per questo pericolo.',
            yes: 'Sì',
          },
          induction: {
            continue: 'Continua',
            induction: 'Induzione',
          },
          index: {
            checkIn: 'Check-in',
            description: 'Completa la seguente valutazione dei rischi per il lavoro selezionato.',
            fail: "Errore nell'elaborazione dei controlli di inizio lavoro.",
            haltMessage:
              'Rischi potenziali rilevati. Interrompi il lavoro, rivedi le linee guida sulla sicurezza e contatta il tuo supervisore per ulteriori istruzioni.',
            header: 'Controlli di inizio lavoro',
            endVisit: 'Termina visita',
            leaveFeedback: 'Lascia un feedback',
          },
          safeToProceed: {
            continue: 'Continua',
            safeToProceed: 'Sicuro per procedere',
          },
        },
      },
    },
    index: {
      title: 'Benvenuto',
      description: 'Scansiona il codice QR nella tua posizione per iniziare.',
    },
    login: {
      errorTitle: 'Errore imprevisto',
      errorMessage: 'Si è verificato un errore imprevisto. Riprova a scansionare il codice QR.',
    },
    unauthenticated: {
      welcome: {
        title: 'Benvenuto su {site}',
        description:
          'Prima di poter visualizzare gli ordini di lavoro, dobbiamo verificare i tuoi dati. Clicca sul pulsante qui sotto per continuare.',
        next: 'Continua',
      },
      index: {
        errorTitle: 'Errore imprevisto',
        errorMessage: 'Si è verificato un errore imprevisto. Riprova a scansionare il codice QR.',
      },
      contractor: {
        title: 'Per chi lavori?',
        contractor: 'Appaltatore',
        contractorLabel: 'Inizia a digitare il nome della tua azienda',
        contractorHint: 'Devi inserire almeno 3 caratteri per vedere i risultati',
        defaultSelectPlaceholder: '--Seleziona--',
        next: 'Avanti',
      },
      user: {
        title: 'Chi sei?',
        cancel: 'Annulla',
        createNewUserLabel: 'Il mio nome non è elencato',
        existingUserLabel: 'Inizia a digitare il tuo nome',
        existingUserHint: 'Devi inserire almeno 3 caratteri per vedere i risultati',
        newUserLabel: 'Inserisci il tuo nome completo',
        next: 'Avanti',
        user: 'Utente',
      },
      verification: {
        methods: {
          add: {
            add: 'Aggiungi metodo di verifica',
            defaultSelectPlaceholder: '--Seleziona--',
            emailLabel: 'Email',
            existingMethodWarning:
              "Hai già una richiesta in sospeso per questo metodo di verifica in attesa di approvazione da parte dell'amministratore. Aggiungerne uno nuovo la sovrascriverà.",
            method: 'Metodo',
            methodLabel: 'Metodo',
            mobileCountryHint: 'Seleziona il prefisso internazionale',
            mobileCountryLabel: 'Prefisso internazionale',
            mobileHint: 'Inserisci il tuo numero di cellulare',
            mobileLabel: 'Cellulare',
            title: 'Aggiungi metodo di verifica',
          },
          confirm: {
            confirm: 'Conferma',
            description: 'Conferma il tuo metodo di verifica per continuare.',
            label: 'Inserisci il tuo codice',
            resend: 'Invia di nuovo',
            resendPrompt: 'Non hai ricevuto un codice?',
            title: 'Conferma metodo di verifica',
          },
          confirmed: {
            description:
              'Verrai avvisato una volta che questo metodo di verifica sarà stato approvato dal tuo amministratore e potrai quindi iniziare a usarlo per verificare la tua identità.',
            forceApproval: "Fino all'approvazione, non puoi accedere agli ordini di lavoro.",
            nonForceApproval:
              'Nel frattempo, puoi continuare ad accedere agli ordini di lavoro con accesso ridotto.',
            nonForceApprovalButtonLabel: 'Continua con accesso ridotto',
            title: 'In attesa di approvazione',
          },
          addNew: 'Aggiungi nuovo metodo di verifica',
          description:
            "Dobbiamo verificare la tua identità per darti pieno accesso all'ordine di lavoro.",
          email: 'Email',
          hint: "Invieremo un link al metodo di verifica selezionato che ti darà pieno accesso all'ordine di lavoro. Se hai bisogno di cambiare i metodi di verifica esistenti, contatta il tuo amministratore.",
          label: 'Seleziona un metodo di verifica',
          next: 'Avanti',
          pendingHint: "In attesa di approvazione da parte dell'amministratore",
          sms: 'SMS',
          title: 'Verifica',
        },
        optional: {
          hint: "Verificare i tuoi dati ti darà pieno accesso all'ordine di lavoro",
          label: 'Vuoi verificare i tuoi dati?',
          next: 'Avanti',
          no: 'No',
          noHint:
            "Non voglio verificare i miei dati e continuare con accesso ridotto all'ordine di lavoro",
          title: 'Verifica',
          yes: 'Sì',
          yesHint: "Voglio verificare i miei dati e ottenere pieno accesso all'ordine di lavoro",
        },
        sent: {
          description:
            "Un link di accesso è stato inviato a {identifier}. Clicca sul link per completare l'accesso.",
          title: 'Link di accesso inviato',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Ieri',
      today: 'Oggi',
      days: {
        monday: 'Lunedì',
        tuesday: 'Martedì',
        wednesday: 'Mercoledì',
        thursday: 'Giovedì',
        friday: 'Venerdì',
        saturday: 'Sabato',
        sunday: 'Domenica',
      },
      months: {
        january: 'Gennaio',
        february: 'Febbraio',
        march: 'Marzo',
        april: 'Aprile',
        may: 'Maggio',
        june: 'Giugno',
        july: 'Luglio',
        august: 'Agosto',
        september: 'Settembre',
        october: 'Ottobre',
        november: 'Novembre',
        december: 'Dicembre',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Qualcosa è andato storto',
      message: 'Riprova a scansionare il codice QR.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Utente sconosciuto',
      },
      none: 'Nessuno',
      types: {
        stateTransition: 'Stato cambiato',
        contractorAssigned: 'Appaltatore assegnato',
        engineerAssigned: 'Ingegnere assegnato',
        serviceAssigned: 'Servizio assegnato',
        priorityChanged: 'Priorità cambiata',
        actionableDateChanged: 'Data attuabile cambiata',
        dueDateChanged: 'Data di scadenza cambiata',
        etaDateChanged: 'Data di arrivo stimata cambiata',
        spendLimitApproved: 'Limite di spesa approvato',
        spendLimitCancelled: 'Richiesta limite di spesa annullata',
        spendLimitRejected: 'Limite di spesa rifiutato',
        spendLimitRequested: 'Limite di spesa richiesto',
        jobSheetUploaded: 'Scheda di lavoro caricata',
        slaAlertSent: 'Avviso SLA per tempo di intervento superato',
        issuedWorkPermit: 'Permesso di lavoro emesso',
        requestForServiceSent: 'Richiesta di servizio inviata',
        comment: 'Commento aggiunto',
        unknown: 'Evento sconosciuto',
      },
      labels: {
        actionableDate: 'Data attuabile',
        comment: 'Commento',
        file: 'File',
        contractor: 'Appaltatore',
        dueDate: 'Data di scadenza',
        etaDate: 'Data di arrivo stimata',
        engineer: 'Ingegnere',
        priority: 'Priorità',
        requestForService: 'Richiesta di servizio',
        service: 'Servizio',
        spendLimit: 'Limite di spesa',
        status: 'Stato',
        workPermit: 'Permesso di lavoro',
      },
    },
  },
}
